import * as F from './Functions'

const env      = F.getEnv()
let LBASE_URL  = ""
let LBASE_BACK = ""

export const LOGO_COPA   = "/img/copaKnauf.png"
export const LOGO_KNAUF  = "/img/logo_knauf.png"
export const LOGO_KNAUF2 = "/img/logo_knauf_2.png"
export const ICON_BACK   = "/img/iconsBack.png"
export const ICON_BR     = "/icon/iconBR.png"

if (env === 1) {
    LBASE_URL  = 'https://api-copa.talentumtecnologia.com.br/api/'
    LBASE_BACK = 'https://api-copa.talentumtecnologia.com.br'
}

if (env === 2) {
    LBASE_URL  = 'http://api-copa-homolog.talentumtecnologia.com.br/api/'
    LBASE_BACK = 'http://api-copa-homolog.talentumtecnologia.com.br'
}

if (env === 3) {
    LBASE_URL  = 'http://127.0.0.1:8000/api/'
    LBASE_BACK = 'http://127.0.0.1:8000'
}
// Talentum
if (env === 4) {
    LBASE_URL  = 'http://api-copa-homolog.talentumtecnologia.com.br/api/'
    LBASE_BACK = 'http://api-copa-homolog.talentumtecnologia.com.br'
}

export const BASE_URL  = LBASE_URL
export const BASE_BACK = LBASE_BACK

export const HEADER_HTTP_TOKEN = { 
    headers: { 
        'Content-Type' : 'application/json',
        'Accept':  'application/json',
        'Authorization': `Bearer ${F.GetToken()}` 
    } 
}

export const HEADER_HTTP = { 
    headers: { 
        'Content-Type' : 'application/json',
        'Accept':  'application/json'
    } 
}
